import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { generatePath, useLocation, useParams } from 'react-router-dom';

import { UniversignValidationCoordonneesRequestSource } from '@/api/placementApi.schemas';
import { usePostApiUniversignSauvegardeFichier } from '@/api/universign/universign';
import UniversignDocumentsForm from '@/components/JustificatifsUniversign/UniversignDocumentsForm';
import { ROUTE } from '@/constants/route';
import useArbitrageValidationMutation from '@/hooks/useArbitrageValidationMutation';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';
import { BreadcrumbItem } from '@/services/types/Breadcrumb';
import { log } from '@/utils/functions/logger/logger';

const ArbitrageCertificates: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { state } = useLocation();

  const idSouscription = (state?.idSouscription ?? 0) as number;
  const storageKey = `parcoursArbitrageData_${id ?? ''}`;

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      label: t('arbitrageSummary.breadcrumbLabel'),
      path: generatePath(ROUTE.ARBITRAGESUMMARY, { id: id ?? '' }),
    },
    {
      label: t('justificatifsUniversign.pageTitle'),
      path: generatePath(ROUTE.ARBITRAGEJUSTIFICATIFS, { id: id ?? '' }),
    },
  ];

  useEffect(() => () => sessionStorage.removeItem(storageKey), [storageKey]);

  const sauvegarderMutation = usePostApiUniversignSauvegardeFichier({
    mutation: {
      onError: (error) => {
        log.error(`usePostApiUniversignSauvegardeFichier failed: ${error}`);
      },
    },
  });

  const validationMutation = useArbitrageValidationMutation({
    id: id ?? '',
    idSouscription,
    breadcrumbItems,
    storageKey,
  });

  useEffect(() => {
    TRACKING_INSTANCE.setTcVars({
      page_nom: 'mes_justificatifs',
      page_template: 'espace client',
    });
    void TRACKING_INSTANCE.triggerEvent('page', undefined, {
      event_id: 'page',
      tunnel_produit: 'tunnel_unique',
      event_categorie: 'affichage espace client',
      event_nom: 'mes_justificatifs',
      event_page: 'mes_justificatifs',
    });
  }, []);

  return (
    <UniversignDocumentsForm
      idSouscription={idSouscription}
      sessionStorageDataKey={storageKey}
      coordonneesSource={UniversignValidationCoordonneesRequestSource.arbitrage}
      universignError={state?.universignError ?? null}
      validFile={state?.validFile ?? {}}
      breadcrumbItems={breadcrumbItems}
      showOrigineFonds={false}
      showTelephone={false}
      sauvegarderMutation={sauvegarderMutation}
      validationMutation={validationMutation}
    />
  );
};

export default ArbitrageCertificates;
